import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for creating a marker
 */
export interface CreateMarkerVariables {
  assetId: string;
  markIn: string;
  markOut?: string;
  markInSeconds?: number;
  markOutSeconds?: number;
  title?: string;
  description?: string;
}

/**
 * Asset reference in created marker
 */
export interface CreatedMarkerAsset {
  id: string;
}

/**
 * Created marker structure
 */
export interface CreatedMarker {
  asset: CreatedMarkerAsset;
  title: string | null;
  description: string | null;
  markIn: string;
  markOut: string | null;
}

/**
 * Create marker mutation response payload
 */
export interface CreateMarkerPayload {
  __typename: string;
  marker: CreatedMarker;
}

/**
 * Response structure for createMarker mutation
 */
export interface CreateMarkerResponse {
  createMarker: CreateMarkerPayload;
}

const createMarker: DocumentNode = gql`
  mutation createMarker(
    $assetId: ID!,
    $markIn: String!,
    $markOut: String,
    $markInSeconds: Float,
    $markOutSeconds: Float,
    $title: String,
    $description: String
  ) {
    createMarker(
      assetId: $assetId,
      markIn: $markIn,
      markOut: $markOut,
      markInSeconds: $markInSeconds,
      markOutSeconds: $markOutSeconds,
      title: $title,
      description: $description
    ) {
      __typename
      marker {
        asset {
          id
        }
        title
        description
        markIn
        markOut
      }
    }
  }
`;

export default createMarker;
